<div class="ddr-main-container" style="max-height: calc(100vh - 180px); overflow: auto;">
    <owc-card class="ddr-one-card">
      <owc-component-header class="ddr-header">
        <!-- <div *ngIf="isInDialog()" class="title-row">
                <span class="mat-title">Due date and reminders</span>
                <owc-button mat-icon-button (click)="onDialogCancel()" class="close-button">
                    <owc-icon>close</owc-icon>
                </button>
            </div> -->

        <span class="mat-title">Due date and reminder</span>
        <owc-switch
          [(ngModel)]="DueDateEnabled"
          [disabled]="!feedbackEnabled"
          (ngModelChange)="updateEnabled($event)"
        >
          Enabled
        </owc-switch>
      </owc-component-header>
  
      <div *ngIf="!DueDateEnabled" class="ddr-disabled-info">
        The notification will not have a due date and will never be overdue.
      </div>
  
      <div *ngIf="DueDateEnabled">
        <!-- Due date section -->
        <div class="ddr-duedate-section">
          <h4>Due date</h4>
          <p>Set the date, by which the customer should provide feedback the latest:</p>
  
          <owc-datepicker
            size="small"
            label="Feedback due date"
            variant="outlined"
            format = "dd-MMM-yyyy"
            [disabledDates]="feedbackDueDateFilter"
            [formControl]="feedbackDueDate"
            (valueChange)="getFeedbackDueDate(feedbackDueDate.value)"
            style="display: flex;"
            >
          </owc-datepicker>

        </div>
  
        <!-- Reminder section -->
        <div class="ddr-reminder-section">
          <h4>Reminder(s)</h4>
          <p>Click on "Add reminder" to add the reminder(s) you want to send to the customer.</p>
  
          <div class="ddr-reminder-table-container">
            <dl-reminder-table
              *ngIf="remindersData.length > 0"
              [displayedColumns]="remindersColumn"
              [tableData]="remindersData"
              [addMoreReminder]="addMoreReminders"
            ></dl-reminder-table>
          </div>
  
          <div class="ddr-add-reminder-button">
            <owc-button
              (click)="openReminderTemplateDialog()"
              [disabled]="!feedbackDueDate.value || feedbackDueDate.invalid"
              class="btn-add-reminder"
              mat-stroked-button
              one-secondary-button
            >
              <span>Add Reminder</span>
            </owc-button>
  
            <owc-modal-dialog #modalDialogElement [(ngModel)]="reminderVisible" size="medium">
              <dl-reminder-message-templete-dialog
                *ngIf="reminderVisible"
                [data]="data"
                (dialogClose)="onReminderDialogClose($event)"
              ></dl-reminder-message-templete-dialog>
            </owc-modal-dialog>
          </div>
        </div>
      </div>
    </owc-card>
  </div>
  